import { asyncAction } from '../common';
import { getEvents, getEventsCsv } from '../../reducers/analyticsApp';
import { PARAM_CSV } from '../../utils/csv';
import { getTypeField } from '../../utils/event/createQueries';
import { dateTypes } from '../../constants/metainf';
import {
  removeComposeEvent,
  setAggregationType,
  setGroupColumn,
  setName,
  setSplitColumn,
} from './events';
import executeEventQueriesCsv from '../../api/eventsCsv';

const notTotal = {
  [PARAM_CSV.SUM]: false,
  [PARAM_CSV.MAX]: false,
  [PARAM_CSV.MIN]: false,
  [PARAM_CSV.AVG]: false,
};

export const downloadCsvResult = () =>
  asyncAction('EXECUTE_EVENT_QUERIES_CSV', executeEventQueriesCsv());

export const setEventCsvColumn = (csv) => ({
  type: 'SET_EVENT_CSV_COLUMN',
  csv,
});

export const setEventAggregationType = (id, aggregationType) => (dispatch, getState) => {
  dispatch(setAggregationType(id, aggregationType));
  const state = getState();

  const isField = getEvents(state).find(({ aggregationColumn }) => !!aggregationColumn);

  if (!isField) {
    dispatch(setEventCsvColumn(notTotal));
  }
};

export const removeEvent = (id) => (dispatch, getState) => {
  let state = getState();
  const isField = getEvents(state).find(({ aggregationColumn }) => aggregationColumn);

  if (isField) {
    dispatch(setEventCsvColumn(notTotal));
  }

  dispatch(removeComposeEvent(id));
  state = getState();

  // при удалении ивента отключается сплит, если он был включен и не является сплитом с типом даты.
  if (getEventsCsv(state)[PARAM_CSV.SPLIT_BY]) {
    const isSplit = getEvents(state).some(
      ({ splitColumn }) =>
        !!splitColumn && !dateTypes.includes(getTypeField(splitColumn, state).type)
    );

    if (!isSplit) {
      dispatch(setEventCsvColumn({ [PARAM_CSV.SPLIT_BY]: isSplit }));
    }
  }

  // при удалении ивента отключается сплиты с типом дата, если все остальные сплиты не являются датой.
  if (getEventsCsv(state)[PARAM_CSV.SPLIT_BY_DAY] && getEventsCsv(state)[PARAM_CSV.SPLIT_BY_MS]) {
    const isSplitDate = getEvents(state).some(({ splitColumn }) =>
      dateTypes.includes(getTypeField(splitColumn, state).type)
    );

    if (!isSplitDate) {
      dispatch(
        setEventCsvColumn({
          [PARAM_CSV.SPLIT_BY_DAY]: false,
          [PARAM_CSV.SPLIT_BY_MS]: false,
        })
      );
    }
  }
};

export const setEventsGroupColumn = (groupColumn) => (dispatch, getState) => {
  const state = getState();
  const newType = getTypeField(groupColumn, state).type;
  const typeIsDate = dateTypes.includes(newType);
  dispatch(
    setEventCsvColumn({
      [PARAM_CSV.GROUP_BY]: !typeIsDate,
      [PARAM_CSV.GROUP_BY_DAY]: typeIsDate,
      [PARAM_CSV.GROUP_BY_MS]: false,
    })
  );

  return dispatch(setGroupColumn(groupColumn));
};

export const setEventSplitColumn = (id, splitColumnParam) => (dispatch, getState) => {
  dispatch(setSplitColumn(id, splitColumnParam));
  const state = getState();

  const events = getEvents(state);
  const splitDate = events
    .filter(({ splitColumn }) => splitColumn)
    .some(({ splitColumn }) => dateTypes.includes(getTypeField(splitColumn, state).type));

  const isSplit =
    (!!splitColumnParam && !dateTypes.includes(getTypeField(splitColumnParam, state).type)) ||
    events.some(
      (event) =>
        event.id !== id &&
        event.splitColumn &&
        !dateTypes.includes(getTypeField(event.splitColumn, state).type)
    );

  dispatch(
    setEventCsvColumn({
      [PARAM_CSV.SPLIT_BY]: isSplit,
      [PARAM_CSV.SPLIT_BY_DAY]: splitDate,
      [PARAM_CSV.SPLIT_BY_MS]: false,
    })
  );
};

export const setEventName = (id, name, eventMetainf) => (dispatch, getState) => {
  dispatch(setName(id, name, eventMetainf));

  const state = getState();

  // при смене ивента отключается сплит, если он был сброшен.
  if (getEventsCsv(state)[PARAM_CSV.SPLIT_BY]) {
    const isSplit = getEvents(state).some(
      ({ splitColumn }) =>
        !!splitColumn && !dateTypes.includes(getTypeField(splitColumn, state).type)
    );

    if (!isSplit) {
      dispatch(setEventCsvColumn({ [PARAM_CSV.SPLIT_BY]: isSplit }));
    }
  }
};
